import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { quizAPI } from '../services/api';
import { FiArrowLeft, FiBook, FiPlay, FiLock } from 'react-icons/fi';

const MyCourses = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const API_BASE_URL = 'http://localhost/recc'; // Base URL for images

  useEffect(() => {
    fetchPurchasedCourses();
  }, []);

  const fetchPurchasedCourses = async () => {
    try {
      const response = await quizAPI.getMyPurchasedCourses(user.email);
      if (response.data.success) {
        setCourses(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching courses:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center">
            <Link to="/dashboard" className="mr-4 p-2 rounded-lg hover:bg-gray-100">
              <FiArrowLeft className="w-5 h-5" />
            </Link>
            <h1 className="text-2xl font-bold text-gray-800">My Courses</h1>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {loading ? (
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-4 border-primary-500 mx-auto"></div>
            <p className="text-gray-600 mt-4">Loading courses...</p>
          </div>
        ) : courses.length === 0 ? (
          <div className="card text-center py-12">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <FiBook className="w-12 h-12 text-gray-400" />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">No Courses Yet</h3>
            <p className="text-gray-600 mb-6">You haven't purchased any courses</p>
            <Link to="/dashboard" className="btn-primary inline-block">
              Go to Dashboard
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.map((course) => (
              <div
                key={course.id}
                className="card hover:shadow-xl transition-all cursor-pointer group"
                onClick={() => navigate(`/course/${course.id}`, { state: { course } })}
              >
                {/* Course Thumbnail */}
                <div className="relative mb-4 rounded-lg overflow-hidden">
                  {course.course_thumbnail ? (
                    <img
                      src={`${API_BASE_URL}/${course.course_thumbnail}`}
                      alt={course.title}
                      className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect fill="%236366f1" width="200" height="200"/%3E%3C/svg%3E';
                      }}
                    />
                  ) : (
                    <div className="w-full h-48 bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center">
                      <FiBook className="w-16 h-16 text-white" />
                    </div>
                  )}
                  <div className="absolute top-3 right-3 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                    Purchased
                  </div>
                </div>

                {/* Course Info */}
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {course.title}
                  </h3>
                  
                  {course.description && (
                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                      {course.description.replace(/(<([^>]+)>)/gi, '')}
                    </p>
                  )}

                  <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                    <span className="flex items-center">
                      <FiBook className="mr-1" />
                      {course.tradegroupName || 'General'}
                    </span>
                    {course.validity && (
                      <span className="text-green-600 font-medium">
                        {course.validity} days
                      </span>
                    )}
                  </div>

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/course/${course.id}`, { state: { course } });
                    }}
                    className="btn-primary w-full flex items-center justify-center group-hover:shadow-md"
                  >
                    <FiPlay className="mr-2" />
                    View Content
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default MyCourses;

